import axios from 'axios'

export default function setup() {
axios.interceptors.request.use(function(config) {
  if (config.method == 'post' || config.method == 'get') {
      const auth_token = sessionStorage.getItem('token');
      const servicio = localStorage.getItem('servicio');
      const modulo = localStorage.getItem("modulo");
      const usuario = localStorage.getItem('usuario');
        if(auth_token) {
          config.headers.Authorization = `Bearer ${auth_token}`;
          config.headers.usuario = usuario;
          config.headers.servicio = servicio;
          config.headers.modulo = modulo;
        } 
  }
    return config;
  }, function(err) {
    return Promise.reject(err);
  });
}